export enum TipoValorParametroImpositivo {
    Alicuota = 0,
    ValorFijo = 1
}